import { render, staticRenderFns } from "./VideoPlayerLive.vue?vue&type=template&id=f17961a8&"
import script from "./VideoPlayerLive.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerLive.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerLive.vue?vue&type=style&index=0&id=f17961a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports